import { ICellRendererParams } from 'ag-grid-community'
import { UserType, UserTypeLabels } from 'types'

const updatedByOrgRenderer = (
  props: ICellRendererParams<{
    creator: { email: string; firstname: string; lastname: string; type: UserType[] }
  }>,
) => {
  const { firstname, lastname, email, type } = props?.data?.creator || {}

  let value = `${firstname} ${lastname}`
  if (type?.length) {
    value += ' / ' + type.map((t) => UserTypeLabels[t]).join(', ')
  }
  value = email ? value + ' / ' + email : value
  return value
}

export default updatedByOrgRenderer
